import React from 'react';
import Spinner, { SpinnerSize } from '../../shared/spinner/Spinner';

interface IOwnProps {
    modifierClass?: string;
    disabled?: boolean;
    spinning?: boolean;
    onClick?: (e: React.FormEvent<HTMLAnchorElement> |React.MouseEvent<HTMLElement>) => void;
}

type Props = IOwnProps;

class LinkButton extends React.Component<Props, {}> {
    public render() {
        return <a href="/#" className={'button'.cAppend(this.props.modifierClass).cAppend(this.props.disabled, 'is-disabled').cAppend(this.props.spinning, 'is-spinning is-disabled')} onClick={this.handleClick}>
            <span className="text">{this.props.children}</span>
            {this.props.spinning && <span className="spin"><Spinner size={SpinnerSize.Small} /></span>}
        </a>;
    }

    private handleClick = (e: React.FormEvent<HTMLAnchorElement> | React.MouseEvent<HTMLElement>) => {
        e.persist();
        e.preventDefault();

        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(e);
        }
    }
}

export default LinkButton;